<template>
  <div class="chat-im-company">
    <ChatContainer
        placeholder="请描述您的问题"
        title="诚通互联在线客服" @send="onSend"
        :messages="messages">
      <template v-slot:bottom-left>
        <a :href="helpCenterHref" target="_blank" class="rtm-help-center">帮助中心</a>
      </template>
    </ChatContainer>
  </div>
</template>

<script>
/* eslint-disable */
import ChatContainer from '@/components/ChatContainer';
import {SharedRtmInfo} from '@/components/mixins';
import {getMemberMetaInfo} from '@/http';

function computeStorageId(ids) {
  const assignedIdKey = 'cyhr:chat:company:assigned';
  const cachedId = localStorage.getItem(assignedIdKey);
  const time = new Date().getTime(), ex = 24 * 60 * 60 * 1000;
  if (cachedId) {
    const [id, expire] = cachedId.split('|');
    if (parseInt(expire) > time && ids.indexOf(id) >= 0) {
      return id;
    }
  }
  if (!ids.length) {
    return null;
  }
  // 24 小时过期
  const selected = ids[0], expire = [selected, time + ex].join('|');
  localStorage.setItem(assignedIdKey, expire);
  return selected;
}

export default {
  name: 'ImCompany',
  mixins: [SharedRtmInfo],
  components: {ChatContainer},
  props: {
    options: Object,
  },
  data() {
    const item = this.newMessageItem('您好，请问有什么可以帮助到您？', '123456', 'accept');
    return {
      consumerServiceIds: {},
      assignedId: null,
      messages: [item],
    };
  },
  computed: {
    helpCenterHref() {
      return APPLICATION_CONTEXT + '/public/overview/overview.html';
    },
  },
  methods: {
    onLogin() {
      setTimeout(() => {
        this.leaveChannel(this.publicChannel);
      }, 15 * 1000);
    },
    getAssignedId() {
      if (this.assignedId) {
        return this.assignedId;
      }
      const selected = computeStorageId(Object.keys(this.consumerServiceIds || {}).sort(() => {
        const value = parseInt(`${Math.random()}`.charAt(2));
        return value == 5 ? 0 : (value > 5 ? 1 : -1);
      }));
      this.assignedId = selected;
      return selected;
    },
    // 用户接受的消息类型不同，可能是客服解答消息，可能是客服 tell me 消息
    onMessageFromPeer(message, peerId) {
      const msg = JSON.parse(message.text);
      if (msg.type === 'tellMe') {
        this.consumerServiceIds[peerId] = msg.me;
        getMemberMetaInfo(peerId);
        this.$emit('available');
      } else {
        const item = this.newMessageItem(msg, peerId, 'accept');
        this.messages.push(item);
        this.$emit('notify', msg, item.name, 8000);
      }
    },
    onJoinPublicChannel(channelName, args) {
    },
    onSend(text) {
      const peerId = this.getAssignedId();
      if (peerId instanceof Promise) {
        peerId.then(id => this.doSendToPeerId(text, id));
      } else {
        this.doSendToPeerId(text, peerId);
      }
    },
    doSendToPeerId(text, peerId) {
      const {options} = this;
      const thisAccountId = options.accountId;
      const message = JSON.stringify({
        name: options.name,
        accountId: options.accountId,
        text,
      });
      this.sendPeerMessage(message, peerId).then(status => {
        if (!status.hasPeerReceived) {
          this.sendFailed(text, thisAccountId);
        }
      }, () => this.sendFailed(text, thisAccountId));
      this.messages.push(this.newMessageItem(text, thisAccountId, 'send'));
    },
    sendFailed(text, accountId) {
      this.$emit('notifyError', `[发送失败]${text}, 请刷新页面或电话联系`, '[提醒]发送失败');
      const item = this.newMessageItem(`[发送失败]“${text}”，请刷新页面或电话联系客服!`, accountId, 'error');
      this.messages.push(item);
    },
  },
};
</script>

<style scoped>
.chat-im-company {
  height: 100%;
  width: 100%;
}

.rtm-help-center {
  color: #3EB2D9;
  font-size: 12px;
  line-height: 28px;
}
</style>